import React, { useEffect, useRef } from "react";
import { Chart } from "chart.js/auto";
import { modelAGF } from "../hooks/useModel";

const EfficiencyByRentChart = ({
  square,
  loanAmount,
  interestRate,
  loanPeriod,
  checkbox,
  keyRate,
  discountRate,
}) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    const rents = [];
    const efficiencies = [];
    const benchmark = [];

    // Перебираем арендную ставку от 0 до 1500 с шагом 50
    for (let r = 0; r <= 1500; r += 50) {
      rents.push(r);
      const m = modelAGF(
        square,
        r,
        loanAmount,
        interestRate / 100,
        loanPeriod,
        checkbox,
        keyRate,
      );
      const eff = m.meanProfitabilityI ? m.meanProfitabilityI * 100 : 0;
      efficiencies.push(eff);
      benchmark.push(discountRate * 100);
    }

    if (chartInstance.current) chartInstance.current.destroy();

    chartInstance.current = new Chart(chartRef.current, {
      type: "line",
      data: {
        labels: rents,
        datasets: [
          {
            label: "Эффективность вложений",
            data: efficiencies,
            borderColor: "black",
            borderWidth: 3,
            fill: false,
            tension: 0.4,
            pointRadius: 0,
          },
          {
            label: "Эталонная ставка для сравнения",
            data: benchmark,
            borderColor: "rgb(255, 99, 132)",
            borderWidth: 2,
            borderDash: [5, 5],
            fill: false,
            tension: 0,
            pointRadius: 0,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          title: {
            display: true,
            text: "Анализ эффективности вложений от Арендной ставки",
            font: {
              family: "Montserrat, sans-serif",
              size: 16,
              weight: "bold",
            },
          },
          legend: {
            position: "bottom",
            labels: { font: { family: "Montserrat, sans-serif", size: 10 } },
          },
        },
        scales: {
          y: {
            beginAtZero: true,
            title: { display: true, text: "Показатель эффективности, %" },
            ticks: { callback: (val) => val + "%" },
          },
          x: {
            title: { display: true, text: "Арендная ставка, руб/м² в месяц" },
          },
        },
      },
    });

    return () => {
      if (chartInstance.current) chartInstance.current.destroy();
    };
  }, [
    square,
    loanAmount,
    interestRate,
    loanPeriod,
    checkbox,
    keyRate,
    discountRate,
  ]);

  return (
    <canvas ref={chartRef} style={{ width: "100%", maxHeight: "400px" }} />
  );
};

export default EfficiencyByRentChart;
